import kit1 from '../assets/images/kits/kit-expo.png';
import kit2 from '../assets/images/kits/kit-corporativo.png';
import kit3 from '../assets/images/kits/kit-oficina.png';
import kit4 from '../assets/images/kits/kit-deportivo.png';
import kit5 from '../assets/images/kits/kit-hombre.png';
import kit6 from '../assets/images/kits/kit-mujer.png';
import kit7 from '../assets/images/kits/kit-viaje.png';
import kit8 from '../assets/images/kits/kit-escolar.png';
import kit9 from '../assets/images/kits/kit-tecnologico.png';
import kit10 from '../assets/images/kits/kit-children.png';

export const categoriesList =  [
    {
        general_category: "BEBIDAS",
        master_category: [
            {
                categories: [
                    {
                        category: "VIDRIO"
                    },
                    {
                        category: "CILINDROS METÁLICOS"
                    },
                    {
                        category: "CILINDROS PLÁSTICOS"
                    }
                ],
                master_category: "CILINDROS"
            },
            {
                master_category: "TAZAS"
            },
            {
                master_category: "TERMOS"
            },
            {
                master_category: "VASOS"
            }
        ]
    },
    {
        general_category: "BIENESTAR",
        master_category: [
            {
                categories: [
                    {
                        category: "ANTIESTRÉS"
                    },
                    {
                        category: "ARTÍCULOS MÉDICOS"
                    },
                    {
                        category: "HIGIENE Y CUIDADO PERSONAL"
                    },
                    {
                        category: "PASTILLEROS"
                    }
                ],
                master_category: "SALUD"
            },
            {
                categories: [
                    {
                        category: "COSMETIQUERAS Y ALHAJEROS"
                    },
                    {
                        category: "COSTUREROS"
                    },
                    {
                        category: "ESPEJOS Y CEPILLOS"
                    },
                    {
                        category: "SETS DE BROCHAS Y MANICURE"
                    }
                ],
                master_category: "BELLEZA"
            }
        ]
    },
    {
        general_category: "HOGAR Y HERRAMIENTAS",
        master_category: [
            {
                master_category: "ACCESORIOS DE COCINA"
            },
            {
                master_category: "BAR"
            },
            {
                master_category: "BBQ"
            },
            {
                master_category: "DECORACIÓN"
            },
            {
                master_category: "DESARMADORES"
            },
            {
                categories: [
                    {
                        category: "HERRAMIENTAS"
                    }
                ],
                master_category: "SET DE HERRAMIENTAS Y MULTIFUNCIONALES"
            },
            {
                master_category: "JARDINERÍA"
            },
            {
                master_category: "LÁMPARAS"
            },
            {
                master_category: "MASCOTAS"
            },
            {
                master_category: "NAVAJAS"
            },
            {
                master_category: "PORTARRETRATOS"
            },
            {
                categories: [
                    {
                        category: "RELOJES DE ESCRITORIO"
                    },
                    {
                        category: "RELOJES DE PARED"
                    }
                ],
                master_category: "RELOJES"
            }
        ]
    },
    {
        general_category: "OFICINA Y TECNOLOGÍA",
        master_category: [
            {
                master_category: "COMPUTO"
            },
            {
                categories: [
                    {
                        category: "CALCULADORAS"
                    },
                    {
                        category: "CALENDARIOS"
                    },
                    {
                        category: "PORTA NOTAS"
                    },
                    {
                        category: "PORTAGAFETE"
                    },
                    {
                        category: "SETS PARA ESCRITORIO Y ORGANIZADORES"
                    },
                    {
                        category: "TARJETEROS"
                    }
                ],
                master_category: "ACCESORIOS DE ESCRITORIO"
            },
            {
                master_category: "AGENDAS"
            },
            {
                categories: [
                    {
                        category: "AUDÍFONOS"
                    },
                    {
                        category: "BOCINAS"
                    }
                ],
                master_category: "AUDIO"
            },
            {
                categories: [
                    {
                        category: "BOLÍGRAFOS FUNCIONES"
                    },
                    {
                        category: "BOLÍGRAFOS METÁLICOS"
                    },
                    {
                        category: "BOLÍGRAFOS PLÁSTICO"
                    }
                ],
                master_category: "ESCRITURA"
            },
            {
                categories: [
                    {
                        category: "CARPETAS"
                    },
                    {
                        category: "LIBRETAS DE BOLSILLO"
                    },
                    {
                        category: "LIBRETAS DE ESCRITORIO"
                    },
                    {
                        category: "LIBRETAS ECOLÓGICAS"
                    }
                ],
                master_category: "LIBRETAS Y CARPETAS"
            },
            {
                categories: [
                    {
                        category: "LLAVEROS FUNCIONES"
                    },
                    {
                        category: "LLAVEROS METÁLICOS"
                    }
                ],
                master_category: "LLAVEROS"
            },
            {
                master_category: "USB"
            }
        ]
    },
    {
        general_category: "TEXTILES",
        master_category: [
            {
                master_category: "BOLSAS"
            },
            {
                master_category: "CHAMARRAS Y CHALECOS"
            },
            {
                master_category: "GORRAS Y SOMBREROS"
            },
            {
                master_category: "HIELERAS Y LONCHERAS"
            },
            {
                categories: [
                    {
                        category: "MALETAS DE VIAJE"
                    },
                    {
                        category: "MALETAS SPORT"
                    }
                ],
                master_category: "MALETAS"
            },
            {
                categories: [
                    {
                        category: "MOCHILAS CASUALES"
                    },
                    {
                        category: "MOCHILAS EJECUTIVAS"
                    },
                    {
                        category: "MOCHILAS ESCOLARES"
                    }
                ],
                master_category: "MOCHILAS"
            },
            {
                categories: [
                    {
                        category: "PARAGUAS E IMPERMEABLE"
                    }
                ],
                master_category: "PARAGUAS"
            },
            {
                master_category: "PLAYERAS"
            },
            {
                master_category: "PORTAFOLIOS"
            }
        ]
    },
    {
        general_category: "TIEMPO LIBRE",
        master_category: [
            {
                categories: [
                    {
                        category: "ALCANCÍAS"
                    },
                    {
                        category: "ARTÍCULOS ESCOLARES"
                    },
                    {
                        category: "JUGUETES"
                    }
                ],
                master_category: "NIÑOS"
            },
            {
                categories: [
                    {
                        category: "CARTERAS Y PORTA DOCUMENTOS"
                    }
                ],
                master_category: "CARTERAS"
            },
            {
                categories: [
                    {
                        category: "ARTÍCULOS PARA PLAYA"
                    },
                    {
                        category: "COMPLEMENTOS DE EQUIPAJE"
                    },
                    {
                        category: "CARTERAS Y PORTADOCUMENTOS"
                    },
                    {
                        category: "MALETAS DE VIAJE"
                    }
                ],
                master_category: "VIAJE"
            },
            {
                master_category: "ENTRETENIMIENTO"
            },
            {
                categories: [
                    {
                        category: "ACCESORIOS DEPORTIVOS"
                    },
                    {
                        category: "GOLF"
                    },
                    {
                        category: "SOCCER"
                    }
                ],
                master_category: "DEPORTES"
            }
        ]
    },
    {
        general_category: "OTRAS",
        master_category: [
            {
                categories: [
                    {
                        category: "AUTO"
                    }
                ],
                master_category: "AUTO"
            },
            {
                categories: [
                    {
                        category: "EJECUTIVA"
                    },
                    {
                        category: "MOCHILAS EJECUTIVAS"
                    }
                ],
                master_category: "EJECUTIVA"
            },
            {
                master_category: "KITS"
            },
            {
                master_category: "SEMANAL"
            }
        ]
    }
];

export const kitGroup = [
    {
        id: 1,
        name: "EXPO",
        imgUrl: kit1
    },
    {
        id: 2,
        name: "CORPORATIVO",
        imgUrl: kit2
    },
    {
        id: 3,
        name: "OFICINA",
        imgUrl: kit3
    },
    {
        id: 4,
        name: "DEPORTIVO",
        imgUrl: kit4
    },
    {
        id: 5,
        name: "HOMBRE",
        imgUrl: kit5
    },
    {
        id: 6,
        name: "MUJER",
        imgUrl: kit6
    },
    {
        id: 7,
        name: "VIAJE",
        imgUrl: kit7
    },
    {
        id: 8,
        name: "ESCOLAR",
        imgUrl: kit8
    },
    {
        id: 9,
        name: "TECNOLOGICO",
        imgUrl: kit9
    },
    {
        id: 10,
        name: "NIÑOS",
        imgUrl: kit10
    },
];